import React, { useEffect, useState } from 'react';
import axios from 'axios';

const UserBookings = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchBookings = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get('/api/bookings/my', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        // ✅ Safely handle response shape
        if (res.data && Array.isArray(res.data.bookings)) {
          setBookings(res.data.bookings);
        } else {
          console.warn('Unexpected response format:', res.data);
          setError('Unexpected server response. Please try again later.');
        }
      } catch (err) {
        console.error('Error loading user bookings:', err);
        setError('Failed to load bookings.');
      } finally {
        setLoading(false);
      }
    };

    fetchBookings();
  }, []);

  if (loading) return <div className="p-6 text-gray-500">Loading bookings...</div>;
  if (error) return <div className="p-6 text-red-600">{error}</div>;

  return (
    <div className="max-w-3xl mx-auto p-6">
      <h2 className="text-2xl font-bold mb-4">My Bookings</h2>

      {bookings.length === 0 ? (
        <p className="text-gray-500">You have no bookings yet.</p>
      ) : (
        <table className="min-w-full text-sm text-left border">
          <thead className="bg-gray-100 text-xs text-gray-500 uppercase">
            <tr>
              <th className="p-2">Booking ID</th>
              <th className="p-2">Space</th>
              <th className="p-2">Dates</th>
              <th className="p-2">Plate</th>
              <th className="p-2">Status</th>
            </tr>
          </thead>
          <tbody className="text-gray-700">
            {bookings.map(b => (
              <tr key={b.id} className="border-t">
                <td className="p-2">{b.id}</td>
                <td className="p-2">{b.address || `#${b.space_id}`}</td>
                <td className="p-2">
                  {new Date(b.start_time).toLocaleString()} →<br />
                  {new Date(b.end_time).toLocaleString()}
                </td>
                <td className="p-2">{b.license_plate}</td>
                <td className="p-2">{b.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default UserBookings;
